export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Длина`, `66`, `68`, `70`, `72`, `74`, `76`],
  [`Ширина`, `46`, `48`, `52`, `56`, `60`, `64`],
  [`Длина рукава`, `20`, `20`, `20`, `22`, `22`, `22`]
];
